import { Component, inject } from '@angular/core'

import { BaseDialogComponent } from '@hyperkit'

import { SupportService } from '../../../services/support.service'

@Component({
  standalone: false,
  selector: 'hunt-module-dialog',
  templateUrl: './hunt-module-dialog.component.html',
  styleUrls: ['./hunt-module-dialog.component.scss'],
})
export class HuntModuleDialogComponent extends BaseDialogComponent<
  unknown,
  boolean
> {
  supportService = inject(SupportService)

  public submitted = false
  public error: string
  public isSmallScreen = false

  public talkToCyborg(): void {
    this.dialogRef.close(true)
  }

  public onClose(): void {
    this.dialogRef.close()
  }

  protected initializeOptions(): void {
    this.options = { headerText: 'Hunt Module' }
  }
}
